import { supabase } from "../../supabase";
import { Btn, Modal } from "../../components/ui";
import { NAME_SUFFIXES } from "../../utils/names";
import AddressAutocomplete from "../../components/AddressAutocomplete";
import ChangePasswordForm from "./ChangePasswordForm";

const ProfileSection = ({ user, setUser, setView, editingProfile, setEditingProfile, profileForm, setProfileForm, profileSaved, profileError, saveProfile, editingAddr, setEditingAddr, addrForm, setAddrForm, setAddrName, addrError, setAddrError, saveAddr, deleteAddr, addresses, openNewAddr, openEditAddr, setDefault }) => (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 28 }} className="r-grid">

          {/* Profile card */}
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
              <h2 style={{ fontSize: "20px" }}>Profile</h2>
              {!editingProfile && (
                <Btn small variant="ghost" onClick={() => {
                  const parts = (user.name || "").trim().split(/\s+/);
                  const firstName = parts[0] || "";
                  const lastName = parts.length > 1 ? parts[parts.length - 1] : "";
                  const middleName = parts.length > 2 ? parts.slice(1, -1).join(" ") : "";
                  setProfileForm({ firstName, middleName, lastName });
                  setEditingProfile(true);
                }}>Edit</Btn>
              )}
            </div>

            <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: "var(--radius)", padding: 22 }}>
              {editingProfile ? (
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                    <div>
                      <label style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 6 }}>First Name *</label>
                      <input value={profileForm.firstName} onChange={e => setProfileForm({ ...profileForm, firstName: e.target.value })} placeholder="First name" autoComplete="given-name" />
                    </div>
                    <div>
                      <label style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 6 }}>Last Name *</label>
                      <input value={profileForm.lastName} onChange={e => setProfileForm({ ...profileForm, lastName: e.target.value })} placeholder="Last name" autoComplete="family-name" />
                    </div>
                  </div>
                  <div>
                    <label style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 6 }}>Middle Name</label>
                    <input value={profileForm.middleName} onChange={e => setProfileForm({ ...profileForm, middleName: e.target.value })} placeholder="Middle name (optional)" autoComplete="additional-name" />
                  </div>
                  {profileError && <p style={{ color: "var(--red)", fontSize: "13px", fontFamily: "var(--font-mono)" }}>{profileError}</p>}
                  <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
                    <Btn small onClick={saveProfile}>Save</Btn>
                    <Btn small variant="ghost" onClick={() => setEditingProfile(false)}>Cancel</Btn>
                  </div>
                </div>
              ) : (
                <>
                  {profileSaved && (
                    <p style={{ fontFamily: "var(--font-mono)", fontSize: "11px", color: "var(--green)", marginBottom: 12 }}>✓ Profile updated</p>
                  )}
                  {[["Name", user.name], ["Email", user.email], ["Account type", user.isAdmin ? "Owner" : user.role === "manager" ? "Manager" : "Customer"]].map(([k, v]) => (
                    <div key={k} style={{ marginBottom: 14, paddingBottom: 14, borderBottom: "1px solid var(--border)" }}>
                      <p style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 3 }}>{k}</p>
                      <p style={{ fontSize: "14px", color: k === "Account type" && user.isAdmin ? "var(--amber)" : "var(--text)" }}>{v}</p>
                    </div>
                  ))}
                  <Btn small variant="danger" onClick={() => { supabase.auth.signOut(); setUser(null); setView("landing"); }}>Sign Out</Btn>
                </>
              )}
            </div>
          </div>

          {/* Change Password */}
          <div>
            <h2 style={{ fontSize: "20px", marginBottom: 14 }}>Change Password</h2>
            <ChangePasswordForm />
          </div>

          {/* Email preferences */}
          <div style={{ marginTop: 24 }}>
            <h2 style={{ fontSize: "20px", marginBottom: 14 }}>Email Preferences</h2>
            <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: "var(--radius)", padding: 22, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div>
                <p style={{ fontSize: "14px", fontWeight: 600, marginBottom: 4 }}>Product updates &amp; announcements</p>
                <p style={{ fontSize: "13px", color: "var(--text-dim)" }}>Receive emails about new products, promotions, and store news.</p>
              </div>
              <div onClick={async () => {
                const newVal = !user.marketingOptIn;
                const { error } = await supabase.from("profiles").update({ marketing_opt_in: newVal }).eq("id", user.id);
                if (!error) setUser({ ...user, marketingOptIn: newVal });
              }} style={{ width: 40, height: 22, borderRadius: 11, background: user.marketingOptIn ? "var(--amber)" : "var(--border)", cursor: "pointer", position: "relative", transition: "background 0.2s", flexShrink: 0, marginLeft: 24 }}>
                <div style={{ position: "absolute", top: 3, left: user.marketingOptIn ? 21 : 3, width: 16, height: 16, borderRadius: "50%", background: "#fff", transition: "left 0.2s" }} />
              </div>
            </div>
          </div>

          {/* Address book */}
          <div style={{ marginTop: 24 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
              <h2 style={{ fontSize: "20px" }}>Saved Addresses</h2>
              <Btn small variant="ghost" onClick={openNewAddr}>+ Add</Btn>
            </div>

            {/* Edit / New address modal */}
            <Modal open={!!editingAddr} onClose={() => setEditingAddr(null)} title={editingAddr === "new" ? "New Address" : "Edit Address"}>
              <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                  <div>
                    <label style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 6 }}>Label</label>
                    <input value={addrForm.label} onChange={e => setAddrForm({ ...addrForm, label: e.target.value })} placeholder="e.g. Home, Office" />
                  </div>
                  <div>
                    <label style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 6 }}>First Name</label>
                    <input autoComplete="given-name" value={addrForm.first_name} onChange={e => setAddrName({ first_name: e.target.value })} placeholder="First" />
                  </div>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 110px", gap: 12 }}>
                  <div>
                    <label style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 6 }}>Last Name</label>
                    <input autoComplete="family-name" value={addrForm.last_name} onChange={e => setAddrName({ last_name: e.target.value })} placeholder="Last" />
                  </div>
                  <div>
                    <label style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 6 }}>Middle (opt)</label>
                    <input autoComplete="additional-name" value={addrForm.middle_name} onChange={e => setAddrName({ middle_name: e.target.value })} placeholder="Middle" />
                  </div>
                  <div>
                    <label style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 6 }}>Suffix (opt)</label>
                    <select autoComplete="honorific-suffix" value={addrForm.suffix} onChange={e => setAddrName({ suffix: e.target.value })}>
                      {NAME_SUFFIXES.map(sfx => <option key={sfx} value={sfx}>{sfx || "—"}</option>)}
                    </select>
                  </div>
                </div>
                <div>
                  <label style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 6 }}>Address</label>
                  <AddressAutocomplete
                    values={{ street: addrForm.street, street2: addrForm.street2, city: addrForm.city, state: addrForm.state, zip: addrForm.zip }}
                    onChange={u => setAddrForm(f => ({ ...f, ...u }))}
                  />
                </div>
                {addrError && <p style={{ color: "var(--red)", fontSize: "13px", fontFamily: "var(--font-mono)" }}>{addrError}</p>}
                <div style={{ display: "flex", gap: 8, marginTop: 4, justifyContent: "space-between" }}>
                  <div style={{ display: "flex", gap: 8 }}>
                    <Btn onClick={saveAddr}>Save Address</Btn>
                    <Btn variant="ghost" onClick={() => { setAddrError(""); setEditingAddr(null); }}>Cancel</Btn>
                  </div>
                  {editingAddr !== "new" && (
                    <Btn variant="danger" onClick={async () => { if (window.confirm("Delete this address?")) { await deleteAddr(editingAddr.id); setEditingAddr(null); } }}>Delete</Btn>
                  )}
                </div>
              </div>
            </Modal>

            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {addresses.length === 0 && (
                <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: "var(--radius)", padding: "28px 20px", textAlign: "center" }}>
                  <p style={{ color: "var(--text-dim)", fontSize: "14px", marginBottom: 12 }}>No saved addresses yet.</p>
                  <Btn small onClick={openNewAddr}>Add Address</Btn>
                </div>
              )}
              {[...addresses].sort((a, b) => (b.is_default ? 1 : 0) - (a.is_default ? 1 : 0)).map(addr => (
                <div key={addr.id} style={{
                  background: "var(--surface)",
                  border: `1px solid ${addr.is_default ? "var(--amber-dim)" : "var(--border)"}`,
                  borderRadius: "var(--radius)", padding: "16px 18px",
                }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <span style={{ fontFamily: "var(--font-mono)", fontSize: "11px", fontWeight: 700, color: "var(--amber)", textTransform: "uppercase", letterSpacing: "0.08em" }}>{addr.label || "Address"}</span>
                      {addr.is_default && (
                        <span style={{ fontFamily: "var(--font-mono)", fontSize: "9px", background: "var(--amber)22", color: "var(--amber)", padding: "2px 6px", borderRadius: 2, letterSpacing: "0.06em" }}>DEFAULT</span>
                      )}
                    </div>
                    <div style={{ display: "flex", gap: 6 }}>
                      {!addr.is_default && (
                        <button onClick={() => setDefault(addr.id)} style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", padding: "3px 7px", border: "1px solid var(--border)", borderRadius: 2, transition: "color 0.15s" }}
                          onMouseEnter={e => e.currentTarget.style.color = "var(--amber)"}
                          onMouseLeave={e => e.currentTarget.style.color = "var(--text-muted)"}>Set default</button>
                      )}
                      <button onClick={() => openEditAddr(addr)} style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", padding: "3px 7px", border: "1px solid var(--border)", borderRadius: 2, transition: "color 0.15s" }}
                        onMouseEnter={e => e.currentTarget.style.color = "var(--text)"}
                        onMouseLeave={e => e.currentTarget.style.color = "var(--text-muted)"}>Edit</button>
                      <button onClick={() => deleteAddr(addr.id)} style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", padding: "3px 7px", border: "1px solid var(--border)", borderRadius: 2, transition: "color 0.15s" }}
                          onMouseEnter={e => e.currentTarget.style.color = "var(--red)"}
                          onMouseLeave={e => e.currentTarget.style.color = "var(--text-muted)"}>Delete</button>
                    </div>
                  </div>
                  <p style={{ fontSize: "14px", marginBottom: 2 }}>{addr.name}</p>
                  <p style={{ fontSize: "13px", color: "var(--text-dim)", lineHeight: 1.6 }}>
                    {addr.street}<br />{addr.street2 ? <>{addr.street2}<br /></> : ""}{addr.city}, {addr.state} {addr.zip}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
);

export default ProfileSection;
